import permision_tjtf from "./permision_tjtf"
//批量注册指令
const directives = {
  permision_tjtf
}
//注册的一般写法，循环遍历directives，通过vue.directive注册
export default {
  install(Vue) {
    Object.keys(directives).forEach((key) => {
      Vue.directive(key, directives[key])
    })
  }
}
